import React from "react";

export default function MessageBox(props) {
  return (
    <div
      {...props}
      className={`${props.className} self-stretch px-2 py-3 justify-start items-start gap-[13px] inline-flex`}
    >
      <div className="flex-col justify-start items-start inline-flex">
        <div className="w-10 h-10 flex-col justify-center items-start flex">
          <img
            className="h-10 relative rounded-[100px] border border-basePrimary"
            src={props.profileimg}
          />
        </div>
        <div className="w-2.5 h-2.5 relative">
          <img className="absolute -top-2 -right-2" src={props.activeicon} />
        </div>
      </div>
      <div className="w-full flex-col justify-start items-start gap-1 inline-flex">
        <h3 className="w-full text-[#222222] text-sm font-normal font-['Poppins'] leading-tight">
          {props.name}
        </h3>
        <p className="w-full text-[#222222] text-xs font-light font-['Poppins'] leading-none">
          {props.message}
        </p>
        <p className="text-[#8993a4] text-[8px] font-normal font-['Poppins'] leading-none">
          {props.date} - {props.time}
        </p>
      </div>
    </div>
  );
}
